<div class="form-group">
  <label *ngIf="label" class="form-label">{{ label }}</label>
  <div class="input-container" 
       (mouseenter)="onMouseEnter()" 
       (mouseleave)="onMouseLeave()">
    <div *ngIf="icon" class="input-icon">
      <img *ngIf="icon.includes('.svg')" [src]="icon" alt="icon" class="icon-svg">
      <span *ngIf="!icon.includes('.svg')" [innerHTML]="icon"></span>
    </div>
    
    <input 
      [type]="type"
      [placeholder]="placeholder"
      [value]="value"
      [required]="required"
      [class]="'form-input' + (hasError ? ' error' : '')"
      (input)="onInputChange($event)"
      (focus)="onFocus()"
      (blur)="onBlur()">
    
    <div 
      *ngIf="hasError && errorMessage" 
      class="input-icon error-icon">
      <div class="error-icon-circle">
        <span class="error-icon-exclamation">!</span>
      </div>
    </div>
    
    <div 
      *ngIf="showPasswordToggle && !hasError" 
      class="input-icon password-toggle"
      (click)="togglePasswordVisibility()">
      <img *ngIf="!showPassword" src="assets/icons/password-eye-icon.svg" alt="!show password" class="icon-svg">
      <img *ngIf="showPassword" src="assets/icons/show-eye.svg" alt="show password" class="show-password">
      
    </div>
    
    <app-password-strength-tooltip 
      *ngIf="showPasswordStrengthTooltip"
      [password]="value"
      [show]="showTooltip">
    </app-password-strength-tooltip>
  </div>
  <span *ngIf="hasError && errorMessage" class="error-message">{{ errorMessage }}</span>
</div>
